import { Stack, StackProps } from '@mui/material';
import clsx from 'clsx';

import { classNamesFor } from '../../utils/classNames';
import { actionsGroupVars } from '../variables';

const classNamesFactory = classNamesFor('ActionsGroup');

const classNames = {
  root: classNamesFactory.root(),
};

export type ActionsGroupProps = StackProps & {
  /** `data-testid` attribute value */
  testId?: string;
};

/**
 * Group of actions displayed horizontally.
 * Provides a consistent layout for action buttons, depending on the context, where they are used.
 * Spacing between actions is controlled by the --actionsGroup-gap CSS variable, typically set by parent components (e.g., dialogs or drawers).
 * Gap can be overridden by setting the `gap` prop directly on the component.
 */
export const ActionsGroup = ({
  className,
  gap = actionsGroupVars.refs.gap,
  direction = 'row',
  testId,
  ...rest
}: ActionsGroupProps) => {
  return (
    <Stack
      className={clsx(classNames.root, className)}
      direction={direction}
      gap={gap}
      data-testid={testId}
      {...rest}
    />
  );
};

ActionsGroup.classNames = classNames;
